/*
 * File: usePackageRegistration.ts
 * Author: Austin Robinson
 * Date Created: 2/20/2024
 * Copyright (c) DrivingDoc 2024
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, publicApi } from 'api';

import { RegistrationFormOutputValues } from 'pages/Main/PackageListing/components/RegistrationForm/utils/validationSchema';

export interface PackageRegistrationParams {
  id: string;
  form: RegistrationFormOutputValues;
}

async function registerForPackage(params: PackageRegistrationParams): Promise<object> {
  // get package id and form values
  const { id, form } = params;

  // make api call
  const result = await publicApi.post(`/public/register/${id}`, form);

  // return the data object
  return result;
}

const usePackageRegistration = createMutation<object, PackageRegistrationParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: PackageRegistrationParams) => registerForPackage(variables),
});

export { usePackageRegistration };
